"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _ThemeProvider = require("./ThemeProvider");
const useTheme = () => {
  const theme = (0, _react.useContext)(_ThemeProvider.ThemeContext);
  // Fail fast if dev uses useTheme outside of ThemeProvider
  if (theme instanceof Error) {
    throw theme;
  }
  return theme;
};
var _default = exports.default = useTheme;